const INSERIR_LISTA_FORMULARIOS = (state, payload) => {
  state.items = payload
}

const BUSCANDO = (state, payload) => {
  state.buscando = payload
}

const INSERIR_LISTA_EXPRESSOES_BOOLEANAS = (state, payload) => {
  state.expressoesBooleanas = payload
}

const INSERIR_FORMULARIO_DINAMICO = (state, payload) => {
  state.formularioDinamico = payload
}

const INSERIR_ITEM_OPTIONS = (state, payload) => {

  const formularios = Array.isArray(state.formularioDinamico) 
    ? state.formularioDinamico 
    : [state.formularioDinamico].filter(Boolean)
  
  formularios.forEach(formulario => {
    if (formulario && formulario.corpo && Array.isArray(formulario.corpo)) {
      formulario.corpo.forEach(item => {
        if (item.name === payload.name) {
          item.options = payload.options
        }
      })
    }
  })
  
  state.formularioDinamico = formularios.length === 1 ? formularios[0] : formularios
}

export {
  INSERIR_LISTA_FORMULARIOS,
  BUSCANDO,
  INSERIR_LISTA_EXPRESSOES_BOOLEANAS,
  INSERIR_FORMULARIO_DINAMICO,
  INSERIR_ITEM_OPTIONS
}